export function getQueryString(key) {
	var after = window.location.hash.split("?")[1];
	if (after) {
		var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
		var r = after.match(reg);
		//console.log(r)
		if (r != null) {
			return decodeURIComponent(r[2]);
		} else {
			return null;
		}
	}
}
